import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Admin from "./layout/admin";
import Auth from "./pages/Auth";
import Login from "./pages/Auth/Login";
import Otp from "./pages/Auth/Otp";
import Users from "./pages/Users";
import Drivers from "./pages/Drivers";
import NotificationAll from "./pages/Notification";
import NotificationForm from "./pages/Notification/create";
import Advertisements from "./pages/Advertisements";
import NotFound from "./pages/404";
import Cookies from "js-cookie";
import CreateAd from "./pages/Advertisements/create";
import ModifyAd from "./pages/Advertisements/modify";
import CreateAdmin from "./pages/Admin/create";
import AdminLists from "./pages/Admin";
import ModifyAdmin from "./pages/Admin/modify";
import DriverDetails from "./pages/Drivers/details";
import Coupon from "./pages/Coupon";
import CreateCoupon from "./pages/Coupon/create";
import ModifyCoupon from "./pages/Coupon/modify";
import RideHistory from "./pages/Drivers/rideHistory";
import Blocked from "./pages/Drivers/blocked";
import Approval from "./pages/Drivers/approval";
import UserDetails from "./pages/Users/details";
import PaymentPending from "./pages/Drivers/paymentPending";
import RevenueDashboard from "./pages/Revenue";
import UpcomingPayment from "./pages/Drivers/upcomingPayment";
import RideHistoryLifeTime from "./pages/RideHistoryLifeTime";
import Locality from "./pages/Locality";
import AddDriver from "./pages/Locality/AddDriver";
import ListArea from "./pages/Locality/ListArea";
import Reviews from "./pages/Reviews";
import Activities from "./pages/Activities";
import FeedBack from "./pages/Reviews/Feedback";
import Incentives from "./pages/Incentives";
import CreatePeakHour from "./pages/Incentives/CreatePeakHour";
import ModifyPeakHour from "./pages/Incentives/ModifyPeakHour";
import Summary from "./pages/Incentives/Summary";
import ViewByDriver from "./pages/Incentives/ViewByDriver";
import ClickedUsers from "./pages/Advertisements/ClickedUsers";
import ModifyIncentivePayouts from "./pages/Incentives/ModifiyPayoutAmout";
import RideFare from "./pages/RideFare";
import ModifyRideFare from "./pages/RideFare/Modify";
import ModifyIncentiveTarget from "./pages/Incentives/ModifyIncentiveTarget";

const App = () => {
  const isUserAuthenticated = () => {
    const cookie = Cookies.get("x-admin-auth");
    if (cookie) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <Routes>
        {!isUserAuthenticated() && (
          <Route element={<Auth />}>
            <Route path="/login" element={<Login />}></Route>
            <Route path="/otp" element={<Otp />}></Route>
            <Route path="*" element={<Navigate to="/login" />} />
          </Route>
        )}
        {isUserAuthenticated() && (
          <Route element={<Admin />}>
            {/* <Route path="/" element={<Home />}></Route> */}
            <Route path="/" element={<RevenueDashboard />}></Route>
            <Route path="/ride-fare" element={<RideFare />}></Route>
            <Route path="/ride-fare/edit" element={<ModifyRideFare />}></Route>
            <Route path="/advertisement" element={<Advertisements />}></Route>
            <Route path="/advertisement/create" element={<CreateAd />}></Route>
            <Route path="/advertisement/edit" element={<ModifyAd />}></Route>
            <Route
              path="/advertisement/view-user-list"
              element={<ClickedUsers />}
            ></Route>
            <Route path="/admin" element={<AdminLists />}></Route>
            <Route path="/admin/create" element={<CreateAdmin />}></Route>
            <Route path="/admin/edit" element={<ModifyAdmin />}></Route>
            <Route path="/drivers" element={<Drivers />}></Route>
            <Route path="/drivers/blocked" element={<Blocked />}></Route>
            <Route path="/drivers/approval" element={<Approval />}></Route>
            <Route
              path="/drivers/upcoming_payment"
              element={<UpcomingPayment />}
            ></Route>
            <Route
              path="/drivers/pending_payment"
              element={<PaymentPending />}
            ></Route>
            <Route path="/drivers/details" element={<DriverDetails />}></Route>
            <Route path="/drivers/history" element={<RideHistory />}></Route>
            <Route path="/users" element={<Users />}></Route>
            <Route path="/users/details" element={<UserDetails />}></Route>
            <Route path="/coupons" element={<Coupon />}></Route>
            <Route path="/coupons/create" element={<CreateCoupon />}></Route>
            <Route path="/coupons/edit" element={<ModifyCoupon />}></Route>
            <Route path="/revenue" element={<RevenueDashboard />}></Route>
            <Route path="/activities" element={<Activities />}></Route>
            <Route path="/driver-reviews" element={<Reviews />}></Route>
            <Route path="/user-feedbacks" element={<FeedBack />}></Route>
            <Route
              path="/ride-history"
              element={<RideHistoryLifeTime />}
            ></Route>
            <Route path="/area" element={<Locality />}></Route>
            <Route path="/assign-driver-area" element={<AddDriver />}></Route>
            <Route path="/list-areas" element={<ListArea />}></Route>

            <Route
              path="/notification/all"
              element={<NotificationAll />}
            ></Route>

            <Route
              path="/notification/create"
              element={<NotificationForm />}
            ></Route>

            <Route path="/incentives" element={<Incentives />}></Route>
            <Route
              path="/incentives/create-peak-hour"
              element={<CreatePeakHour />}
            ></Route>
            <Route path="/incentives/edit" element={<ModifyPeakHour />}></Route>
            <Route path="/incentives/summary" element={<Summary />}></Route>
            <Route
              path="/incentives/view-by-driver"
              element={<ViewByDriver />}
            ></Route>
            <Route
              path="/incentives/update-pricing"
              element={<ModifyIncentivePayouts />}
            ></Route>
            <Route
              path="/incentives/update-target"
              element={<ModifyIncentiveTarget />}
            ></Route>
            <Route path="*" element={<NotFound />} />
          </Route>
        )}
      </Routes>
    </>
  );
};

export default App;
